
import {Options, Vue} from 'vue-class-component'
import {isDefined, scrollToTop} from "@/utils";
import LazyLoadContainer from "@/components/LazyLoadComponent.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import SpeakerDetailDialog from "@/components/SpeakerDetailDialog.vue";
import {Services} from "@/Services";
import {Speaker} from "@/entities/Speaker";
import {Speech} from "@/entities/Speech";
import {Observable} from "rxjs/dist/types";
import {zip} from "rxjs";
import {SpeechFilter} from "@/entities/SpeechFilter";


@Options({components: {SpeakerDetailDialog, LazyLoadContainer, LoadingSpinner}})
export default class App extends Vue {

  private searchValue: string = '';
  private isLoading: boolean = true;
  private _speakers: Speaker[] = [];
  private _speeches : Speech[] = [];
  private speechFilter: SpeechFilter = new SpeechFilter({});

  constructor(props: any) {
    super(props);

    const observables: Observable<any>[] = [Services.getSpeechFilters(), Services.getSpeeches(), Services.getSpeakers()];

    zip(...observables).subscribe(values => {
      this.speechFilter = values[0];
      this._speeches = values[1];
      this._speakers = values[2].filter((speaker) => speaker.hasPicture() && !speaker.picture.startsWith('NN_'));

      this.isLoading = false;
    });
  }

  mounted() {
    window.addEventListener('scroll', this.handleScrollEvent);
  }

  private handleScrollEvent(): void {
    if (isDefined(this.$refs.scrollToTopButton)) {
      if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
        (this.$refs.scrollToTopButton as HTMLElement).style.display = "block";
      } else {
        (this.$refs.scrollToTopButton as HTMLElement).style.display = "none";
      }
    }
  }

  private scrollTop(): void {
    scrollToTop();
  }



  private openSpeakerDetailDialog(speaker:Speaker,event:Event) :void{
    event.stopImmediatePropagation()
    if(isDefined(this.$refs.speakerDetailDialog)){
      let speechesForSpeaker: Speech[] = this._speeches.filter(s => s.speakers.find(e => e.id === speaker.id));
      (this.$refs.speakerDetailDialog as SpeakerDetailDialog).openDialog(speaker,speechesForSpeaker)
    }
  }

  private getLangForSpeechById(id): string {
    if (isDefined(id) && isDefined(this.speechFilter)) {
      for (const [key, value] of Object.entries(this.speechFilter.filters)) {
        for (const filter of value) {
          if (filter.id === id) {
            return filter.title;
          }
        }
      }
    }
    return undefined;
  }

  get speakers(): Speaker[] {
    if(isDefined(this.searchValue) && this.searchValue.trim().length > 0){
      return this._speakers.filter(s => s.hasSearchValue(this.searchValue.trim().toLowerCase()));
    }
    return this._speakers;
  }
}
